export type GraphicsQuality = 'low' | 'medium' | 'high';

export interface GraphicsQualityOption {
  label: string;
  value: GraphicsQuality | 'auto';
  description: string;
}

export const GRAPHICS_QUALITY_OPTIONS: GraphicsQualityOption[] = [
  {
    label: 'Low',
    value: 'low',
    description: 'Best performance, reduced visual quality'
  },
  {
    label: 'Medium',
    value: 'medium',
    description: 'Balanced performance and visuals'
  },
  {
    label: 'High',
    value: 'high',
    description: 'Best visual quality, requires good hardware'
  },
  {
    label: 'Auto',
    value: 'auto',
    description: 'Automatically adjust based on performance'
  }
];